import React, { Fragment } from "react";
import Download from "../layout/Download";
import FeaturesSection from "../layout/FeaturesSection";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import Hero from "../layout/Hero";
import Profile from "../layout/Profile";
import Screens from "../layout/Screens";
import SpecialSection from "../layout/SpecialSection";
import Stats from "../layout/Stats";
import Spinner from "../spinner/Spinner";

function Home() {
  return (
    <Fragment>
      <Spinner />
      <Header />
      <Hero />
      <FeaturesSection />
      <Profile />
      <SpecialSection />
      <Screens />
      <Stats />
      <Download />
      <Footer />
    </Fragment>
  );
}

export default Home;
